import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Validate environment variables on startup
import { validateEnvironment, logEnvironmentInfo } from "./lib/env";

// Initialize theme on app load
const initializeTheme = () => {
  const savedTheme = localStorage.getItem('theme') || 'light';
  const root = document.documentElement;
  
  if (savedTheme === 'dark') {
    root.classList.add('dark');
  } else if (savedTheme === 'system') {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDarkMode) {
      root.classList.add('dark');
    }
  }
};

// Apply theme immediately before React renders
initializeTheme();

// Log environment info in development
logEnvironmentInfo();

// Validate required environment variables
const envValidation = validateEnvironment();
if (!envValidation.isValid) {
  console.error("Environment validation failed. Please check your .env file.");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
